// Attach dish accessibility/allergen data from Business/{docId}/menu_accessibility
// (written by newFunctions aiAccessibilityPipeline for POS-imported menus,
// keyed by menu item id, e.g. "item_<squareId>") to DishDetails docs, which
// carry that id as `menuItemId`. A dish's own `accessibility` field wins.
// Option allergens are stored as { [optionName]: allergens[] } and attached
// to matching option items as `allergens` (the shape the app uses).
// Nothing is written; this only reshapes what was read.

export function attachMenuAccessibility(dishes, accessibilityDocs) {
  const byItem = {};
  (accessibilityDocs || []).forEach((doc) => {
    if (!doc) return;
    const key = doc.itemId || doc.id;
    if (key) byItem[key] = doc;
  });
  if (Object.keys(byItem).length === 0) return dishes || [];

  return (dishes || []).map((dish) => {
    const acc = dish.menuItemId ? byItem[dish.menuItemId] : null;
    if (!acc) return dish;
    const optionAllergens = acc.optionAllergens || {};
    const hasOptionAllergens = Object.keys(optionAllergens).length > 0;
    return {
      ...dish,
      accessibility: dish.accessibility || acc,
      dishOptions: hasOptionAllergens
        ? (dish.dishOptions || []).map((group) => ({
            ...group,
            optionItems: (group.optionItems || []).map((item) =>
              !item.allergens && Array.isArray(optionAllergens[item.name]) && optionAllergens[item.name].length
                ? { ...item, allergens: optionAllergens[item.name] }
                : item
            ),
          }))
        : dish.dishOptions,
    };
  });
}
